import { Kind, parse, print } from 'graphql';
export const changeGqlQueryOperationName = (graphqlQuery, newName) => {
    const printedQuery = print(graphqlQuery);
    const parsedQuery = parse(printedQuery);
    const operationDefinition = parsedQuery.definitions.find(definition => {
        if (definition.kind === Kind.OPERATION_DEFINITION) {
            ;
            definition.name = {
                kind: Kind.NAME,
                value: newName,
            };
            return true;
        }
        return false;
    });
    if (!operationDefinition) {
        throw new Error('Operation definition not found');
    }
    return parsedQuery;
};
//# sourceMappingURL=QueryNodeUtils.parts.js.map